var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{attrs:{"columns":_vm.columns,"data":_vm.resources,"size":"small","stripe":""},scopedSlots:_vm._u([{key:"from_branch",fn:function(ref){
var row = ref.row;
return [_vm._v(" "+_vm._s(_vm.$root.$i18n.locale === "kh" ? row.from_branch_name_kh : row.from_branch_name_en)+" ")]}},{key:"to_branch",fn:function(ref){
var row = ref.row;
return [_vm._v(" "+_vm._s(_vm.$root.$i18n.locale === "kh" ? row.to_branch_name_kh : row.to_branch_name_en)+" ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }